(function(){
var L=(document.documentElement.getAttribute('lang')||'').toLowerCase();
var EN=(L.indexOf('en')===0)||(/^\/en(\/|$|\?)/.test(location.pathname));
var T=EN?{
 rtu:'5 L ready-to-use',prairie:'Meadow Green',foret:'Forest Green',
 need:'You need ~',needEnd:' L of concentrate',
 shade:' m\u00b2 \u00b7 recommended shade: ',dil:' \u00b7 dilution ',
 rtuLbl:'The 5 L ready-to-use is enough (pre-dosed, no dilution)',
 freeShip:' \u2014 free delivery',
 proTitle:'Above 25 L, you are a professional:',
 proText:' volume pricing and dedicated support.',
 proBtn:'Contact the pro team',
 reco:'Our recommendation: ',
 add:'Add to cart \u2014 ',
 sheet:'View details'
}:{
 rtu:'5 L pr\u00eat \u00e0 l\u2019emploi',prairie:'Vert Prairie',foret:'Vert For\u00eat',
 need:'Il vous faut ~',needEnd:' L de concentr\u00e9',
 shade:' m\u00b2 \u00b7 teinte conseill\u00e9e : ',dil:' \u00b7 dilution ',
 rtuLbl:'Le 5 L pr\u00eat \u00e0 l\u2019emploi suffit (d\u00e9j\u00e0 dos\u00e9, sans dilution)',
 freeShip:' \u2014 livraison offerte',
 proTitle:'Au-del\u00e0 de 25 L, vous \u00eates un pro :',
 proText:' tarifs d\u00e9gressifs et accompagnement d\u00e9di\u00e9.',
 proBtn:'Contacter l\u2019\u00e9quipe pro',
 reco:'Notre recommandation : ',
 add:'Ajouter au panier \u2014 ',
 sheet:'Voir la fiche'
};
var P={
 s500:{vp:51836220309845,vf:51836223357269,h:'/products/greenclat-vert-prairie-500ml',hf:'/products/greenclat-vert-foret-500ml',px:69.99},
 s1:{vp:51836234596693,vf:51836225651029,h:'/products/greenclat-vert-prairie-1l',hf:'/products/greenclat-vert-foret-1l',px:89.99},
 s5:{vp:51836239544661,vf:51836203794773,h:'/products/greenclat-vert-prairie-5l',hf:'/products/greenclat-vert-foret-5l',px:359.99},
 pack:{vp:54195404800341,vf:54195404833109,h:'/products/colorant-pret-a-lemploi-5-l-jusqua-50-m',hf:'/products/colorant-pret-a-lemploi-5-l-jusqua-50-m',px:49.99}
};
var m2=document.getElementById('c-m2'),ty=document.getElementById('c-type'),res=document.getElementById('c-res');
if(!m2||!res){return}
function num(x){return EN?x.toFixed(2):x.toFixed(2).replace('.',',')}
function money(x){return EN?('\u20ac'+num(x)):(num(x)+' \u20ac')}
function calc(){
 var s=parseFloat(m2.value);
 if(!s||s<1){res.className='calc-res';res.innerHTML='';return}
 var t=ty.value;
 var cov=(t==='sain')?400:200;
 var litres=s/cov;
 var teinte=(t==='haie')?T.foret:T.prairie;
 var lv=(litres<1?num(litres):num(Math.ceil(litres*10)/10));
 var html="<div class='big'>"+T.need+lv+T.needEnd+"</div>";
 html+='<p>'+s+T.shade+"<strong style='color:#A8E063'>"+teinte+'</strong>'+T.dil+(t==='haie'?'1:30':(t==='brule'?'1:30':(EN?'1:40 to 1:50':'1:40 \u00e0 1:50')))+'</p>';
 var reco;
 if(t!=='haie'&&s<=12){reco={p:P.pack,q:1,lbl:T.rtuLbl}}
 else if(litres<=0.5){reco={p:P.s500,q:1,lbl:'1\u00d7 500 mL '+teinte}}
 else if(litres<=1){reco={p:P.s1,q:1,lbl:'1\u00d7 1 L '+teinte+T.freeShip}}
 else if(litres<=2){reco={p:P.s1,q:2,lbl:'2\u00d7 1 L '+teinte+T.freeShip}}
 else if(litres<=25){var n=Math.ceil(litres/5);reco={p:P.s5,q:n,lbl:n+'\u00d7 5 L Pro '+teinte}}
 else{html+="<p><strong style='color:#F5F2EC'>"+T.proTitle+'</strong>'+T.proText+"</p><a class='btn green' href='mailto:info@greeneclat.com'>"+T.proBtn+'</a>';res.innerHTML=html;res.className='calc-res on';return}
 var vid=(teinte===T.foret)?reco.p.vf:reco.p.vp;
 var fiche=(teinte===T.foret)?reco.p.hf:reco.p.h;
 var prix=money(reco.p.px*reco.q);
 html+='<p>'+T.reco+"<strong style='color:#F5F2EC'>"+reco.lbl+'</strong> \u2014 '+prix+'</p>';
 html+="<a class='btn green' href='/cart/add?id="+vid+'&quantity='+reco.q+"'>"+T.add+prix+"</a><a class='fiche' href='"+fiche+"'>"+T.sheet+'</a>';
 res.innerHTML=html;res.className='calc-res on';
}
[m2,ty].forEach(function(el){el.addEventListener('input',calc);el.addEventListener('change',calc)});
calc();
})();
